import React from "react";
import {
  Box,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const CONSTRAINT_OPTIONS = [
  { value: "max_uses", label: "الحد الأقصى للاستخدام" },
  { value: "max_uses_per_user", label: "الحد الأقصى للاستخدام لكل مستخدم" },
  { value: "time_limit", label: "حدود الوقت" },
];

function ConstraintsSection({ constraints, setConstraints }) {
  // Handle checkbox toggle
  const handleToggle = (type) => {
    const exists = constraints.find((c) => c.type === type);
    let updated;
    if (exists) {
      updated = constraints.filter((c) => c.type !== type);
    } else {
      if (type === "time_limit") {
        updated = [...constraints, { type, start_time: "", end_time: "" }];
      } else {
        updated = [...constraints, { type, value: "" }];
      }
    }
    setConstraints(updated);
  };

  // Handle value change for numeric constraints
  const handleValueChange = (type, value) => {
    setConstraints((prev) => prev.map((c) => (c.type === type ? { ...c, value } : c)));
  };

  // Helper to ensure time is in HH:mm:ss format
  const formatTime = (value) => {
    if (!value) return "";
    // If already in HH:mm:ss, return as is
    if (/^\d{2}:\d{2}:\d{2}$/.test(value)) return value;
    // If in HH:mm, add :00
    if (/^\d{2}:\d{2}$/.test(value)) return value + ":00";
    // If in H:mm, pad hour
    if (/^\d{1}:\d{2}$/.test(value)) return "0" + value + ":00";
    return value;
  };

  // Handle time change for time_limit
  const handleTimeChange = (type, field, value) => {
    setConstraints((prev) =>
      prev.map((c) => (c.type === type ? { ...c, [field]: formatTime(value) } : c))
    );
  };

  return (
    <MDBox
      display="flex"
      flexDirection="column"
      gap={3}
      p={{ xs: 1, sm: 2, md: 3 }}
      boxShadow={3}
      borderRadius={4}
      bgcolor="#fff"
      mb={4}
      sx={{
        width: { xs: "100%", md: "90%" },
        margin: "20px auto",
        backgroundColor: "#fff !important",
      }}
    >
      <MDTypography variant="h6" color="text" fontWeight="medium" mb={1}>
        القيود
      </MDTypography>
      <FormControl component="fieldset" variant="standard">
        <FormGroup sx={{ flexDirection: { xs: "column", sm: "row" } }}>
          {CONSTRAINT_OPTIONS.map((option) => (
            <FormControlLabel
              key={option.value}
              control={
                <Checkbox
                  checked={!!constraints.find((c) => c.type === option.value)}
                  onChange={() => handleToggle(option.value)}
                  color="primary"
                />
              }
              label={option.label}
              sx={{ mx: 2 }}
            />
          ))}
        </FormGroup>
      </FormControl>
      {/* Dynamic fields for selected constraints */}
      {constraints.length > 0 && (
        <Box
          display="flex"
          gap={2}
          alignItems="center"
          flexWrap="wrap"
          flexDirection={{ xs: "column", sm: "row" }}
        >
          {constraints.map((constraint) => (
            <React.Fragment key={constraint.type}>
              {constraint.type === "max_uses" && (
                <TextField
                  label="الحد الأقصى للاستخدام"
                  type="number"
                  value={constraint.value}
                  onChange={(e) => handleValueChange("max_uses", e.target.value)}
                  inputProps={{ min: 1 }}
                  sx={{ minWidth: { xs: "100%", sm: 180 }, width: { xs: "100%", sm: "auto" } }}
                  fullWidth
                />
              )}
              {constraint.type === "max_uses_per_user" && (
                <TextField
                  label="الحد الأقصى لكل مستخدم"
                  type="number"
                  value={constraint.value}
                  onChange={(e) => handleValueChange("max_uses_per_user", e.target.value)}
                  inputProps={{ min: 1 }}
                  sx={{ minWidth: { xs: "100%", sm: 180 }, width: { xs: "100%", sm: "auto" } }}
                  fullWidth
                />
              )}
              {constraint.type === "time_limit" && (
                <Box
                  display="flex"
                  gap={2}
                  alignItems="center"
                  flexDirection={{ xs: "column", sm: "row" }}
                >
                  <TextField
                    label="وقت البداية"
                    type="time"
                    value={constraint.start_time}
                    onChange={(e) => handleTimeChange("time_limit", "start_time", e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ step: 1 }}
                    sx={{ minWidth: { xs: "100%", sm: 140 }, width: { xs: "100%", sm: "auto" } }}
                    fullWidth
                  />
                  <TextField
                    label="وقت النهاية"
                    type="time"
                    value={constraint.end_time}
                    onChange={(e) => handleTimeChange("time_limit", "end_time", e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ step: 1 }}
                    sx={{ minWidth: { xs: "100%", sm: 140 }, width: { xs: "100%", sm: "auto" } }}
                    fullWidth
                  />
                </Box>
              )}
            </React.Fragment>
          ))}
        </Box>
      )}
    </MDBox>
  );
}

export default ConstraintsSection;
